module.exports = __webpack_public_path__ + "img/wind-decoration-with-plants.1545b623.jpg";